export enum FilterCondition {
  EQ = 'eq',
  CT = 'ct',
  IN = 'in',
  OR = 'or',
  LE = 'le',
  GE = 'ge',
}
